import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className"];
import React from 'react';
import { Preloader } from '@beef/ui-kit';
import { cnBem } from "../../lib";
import styles from "./styles.pcss";
var cnLoader = cnBem('loader', styles);
export var Loader = function Loader(_ref) {
  var className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cnLoader(null, [className])
  }, otherProps, {
    "data-t-id": "ui-Loader"
  }), /*#__PURE__*/React.createElement(Preloader, {
    color: "contentPlaceholder",
    size: "m"
  }));
};